import { Component, Injector } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NotificationDataService } from '../../../notification-data.service';

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html'
})
export class ChangePasswordDialogComponent {

  public title = 'CHANGE_PASSWORD.TITLE';
  
  constructor(
    protected _injector: Injector,
    public dialogRef: MatDialogRef<ChangePasswordDialogComponent>
  ) { }

  closeAfterSubmit(event){
    this.dialogRef.close()
    this._injector.get(NotificationDataService).openSnackBar(this._injector.get(TranslateService).instant("CHANGE_PASSWORD.SUCCESS_MESSAGE"));
  }

  closeAfterCancel(event){
    this.dialogRef.close()
  }
}
